import 'css-chunksrc/client/pages/personalSpacePage/synthesis/blockedTasksToggle/styles.scss';export default {
  "blockedTasksToggle": "_blockedTasksToggle_1xaks_1",
  "label": "_label_1xaks_11"
};